const Note = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6 4.7C6 2.93269 7.43269 1.5 9.2 1.5H18.8C20.5673 1.5 22 2.93269 22 4.7V19.3C22 21.0673 20.5673 22.5 18.8 22.5H9.2C7.43269 22.5 6 21.0673 6 19.3L6 4.7Z"
        fill="#D6C1FA"
      />
      <path
        d="M2 4.7C2 2.93269 3.43269 1.5 5.2 1.5H13L18 6.5V19.3C18 21.0673 16.5673 22.5 14.8 22.5H5.2C3.43269 22.5 2 21.0673 2 19.3V4.7Z"
        fill="#9E6BF5"
      />
      <path d="M13 6.5V1.5L18 6.5H13Z" fill="#6B16EE" />
      <rect x="5" y="8.29999" width="10" height="1.6" fill="#FAF6FF" />
      <rect x="5" y="12.3" width="10" height="1.6" fill="#FAF6FF" />
    </svg>
  );
};

export default Note;
